// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button-popover{max-width:450px}.button-popover .popover-body{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.button-popover .popover-body .blue{color:#2680eb!important;font-weight:500}", ""]);
// Exports
module.exports = exports;
